import { SidePanel } from "@wix/design-system";
import classNames from "classnames";
import React from "react";
import { ROOT } from "./data-hooks";
import classes from "./fullscreen-mobile-layout-scss";
const FullscreenMobileLayout = ({
  onCloseButtonClick,
  dataHook,
  header,
  content,
  footer,
  sidePanelProps
}) => {
  return /* @__PURE__ */ React.createElement(
    SidePanel,
    {
      onCloseButtonClick,
      height: "100vh",
      width: "100%",
      dataHook: classNames(ROOT, dataHook),
      ...sidePanelProps
    },
    header && /* @__PURE__ */ React.createElement(SidePanel.Header, { showDivider: false, ...header }),
    /* @__PURE__ */ React.createElement(
      SidePanel.Content,
      {
        stretchVertically: true,
        className: classNames({ [classes.content]: true, [classes.contentWithFooter]: footer }),
        ...content
      }
    ),
    footer && /* @__PURE__ */ React.createElement(SidePanel.Footer, { showDivider: true, className: classes.footer, ...footer })
  );
};
export {
  FullscreenMobileLayout
};
//# sourceMappingURL=fullscreen-mobile-layout.js.map
